import React from 'react'
import PropTypes from 'prop-types'

const ImageTextComponent = (props) => {
	const text = <div className='Text'>{props.text.map((text, index) => <p key={index}>{text}</p>)}</div>
	const image = <img className='Image' src={props.image} alt=''/>

	return (
		<div className={'ImageTextComponent ' + props.direction + ' ' + props.startWith + '-first'}>
			{text}
			{image}
		</div>
	)
}

ImageTextComponent.propTypes = {
	text: PropTypes.arrayOf(PropTypes.string).isRequired,
	image: PropTypes.string.isRequired,
	direction: PropTypes.oneOf(['row', 'column']).isRequired,
	startWith: PropTypes.oneOf(['text', 'image']).isRequired

}

export default ImageTextComponent


// WEBPACK FOOTER //
// ./src/components/ImageTextGroupComponent/ImageTextComponent.js